<div class="badge" [ngClass]="'badge-' + color">
  <span>
    {{ count }}
  </span>
</div>
